// Адрес записи задания. И <audio>, и ссылка скачивания идут браузером в обход apiClient: сессионную
// cookie браузер приложит к ним сам, поэтому токена в адресе нет и быть не должно — оттуда он попал бы
// в логи прокси и историю браузера.
// download=true — вложением под исходным именем (кнопка «Скачать» в «Заданиях»). Именно
// true, а не 1: привязка bool в ASP.NET «1» не понимает, и сервер ответил бы 400.
export const buildTaskAudioUrl = (baseUrl, taskId, { download = false } = {}) =>
  `${baseUrl}/tasks/${taskId}/audio${download ? '?download=true' : ''}`;

// Имя файла записи — то же, что в колонке «Файл»: последний сегмент пути в хранилище.
export const taskAudioFileName = (filePath) => {
  const name = filePath?.split('/')?.pop();
  return name || null;
};
